import { render, staticRenderFns } from "./CompetitionsList.vue?vue&type=template&id=318a5488&"
import script from "./CompetitionsList.vue?vue&type=script&lang=ts&"
export * from "./CompetitionsList.vue?vue&type=script&lang=ts&"
import style0 from "./CompetitionsList.vue?vue&type=style&index=0&id=318a5488&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports